import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Router } from '@angular/router';
import { LocalStorageService } from 'ngx-webstorage';
import { TransactionHistoryDetailComponent } from 'src/app/modules/wallet/transaction-history-detail/transaction-history-detail.component';
import { DtoService } from '../../services/dto.service';
import { FunctService } from '../../services/funct.service';
import { NavigationService } from '../../services/navigation.service';

@Component({
  selector: 'app-header',
  templateUrl: './app-header.component.html',
  styleUrls: ['./app-header.component.scss']
})
  
export class AppHeaderComponent implements OnInit {

  @Input() showBack: boolean = false;
  @Input() showDownload: boolean = false;
  @Input() showNoti: boolean = false;
  @Input() showRefresh: boolean = false;
  
  @Output() refreshEvent = new EventEmitter();
  @Output() notificationEvent = new EventEmitter();
  @Output() threedreslutVideoEvent = new EventEmitter();
  @Output() userGuideEvent: EventEmitter<void> = new EventEmitter<void>();
  isUserLoggedIn: any = false;
  notiCount: any = 0;
  token: any;

  constructor(
    private dto: DtoService,
    private funct: FunctService,
    private http: HttpClient,
    private router: Router,
    private storage: LocalStorageService,
    public navigation: NavigationService) {
  }

  ngOnInit(): void {

    this.isUserLoggedIn = this.storage.retrieve('isUserLoggedIn');
    if (this.isUserLoggedIn) {
      if (this.router.url == '/home' || this.router.url == '/wallet' || this.router.url == '/promotion/list' || this.router.url == '/service-phone' || this.router.url == '/profile/me' || this.router.url.includes('/game/list')) {
        this.getAllNoti();
      }
    }

  }

  getAllNoti() { 
    this.token = this.storage.retrieve('token');
    let headers = new HttpHeaders();
    headers = headers.set('Authorization',  this.token);

    this.http.get(this.funct.ipaddress + 'notification/GetNotificationList', { headers: headers }).subscribe(
      result => {
        this.dto.Response = result;        
        this.notiCount = 0;
        this.dto.Response.forEach(e => {
          if (e.status && e.status == "0") {
            this.notiCount++;          
          }
        });
        // this.storage.store('localNewNotiCount', notiCount);
    });
  }

  downloadPage(): void {
    sessionStorage.setItem('rootUrl', null);
    this.router.navigate(['/download'], { replaceUrl: false });
  }
  
  refreshPage(): void{
    if(!this.isUserLoggedIn)
    {
      this.router.navigate(['auth/welcome']);
      return;
    }
    this.ngOnInit();
    this.refreshEvent.emit();  
  }
   
  notificationPage(): void {
    this.notificationEvent.emit();    
  }
 
  threedreslutVideoPage():void
  {
    this.threedreslutVideoEvent.emit();
  }
  userGuideEventPage():void
  {
   this.userGuideEvent.emit();
  }
  //go back
  goBack()
  {
    this.funct.back();
  }
}
